import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../util/axiosconfig";

interface ProtectedRouteProps {
  element: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ element }) => {
  // Check if the token exists; if not, redirect to login
  const navigate = useNavigate();
  var authToken = localStorage.getItem("token");
  // authToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySUQiOjEsImRpc3BsYXlOYW1lIjoiU3VwZXIgQWRtaW4iLCJ1c2VyRW1haWwiOiJhZG1pbkBhbWVsaW8uY29tIiwicm9sZUlEIjoxLCJyb2xlTmFtZSI6IlN1cGVyIEFkbWluIiwiaWF0IjoxNzI2MTUzMzg3LCJleHAiOjE3Mjg3NDUzODd9.Vl0KgZAI1D1torvvYvwqra9TDPU37LNUqd8WnspI1PQ';

  useEffect(() => {
    // If there's no auth token, redirect to the login page
    if (!authToken) {
      navigate("/", { replace: true });
    }

    if (localStorage.currentModuleID) {
      axios
        .get(
          `/user/check-user-role?moduleID=${
            localStorage.currentModuleID ?? null
          }`
        )
        .then((response) => {
          if (
            response.data.isRoleMismatched ||
            (localStorage.isProjectManager &&
              JSON.parse(localStorage.isProjectManager) !==
                response.data.isProjectManager) ||
            (localStorage.userAssociated &&
              JSON.parse(localStorage.userAssociated) !==
                response.data.userAssociated) ||
            response.data.isHSUserFormMappingChanged
            // response.data.isStillLineManager === false
          ) {
            localStorage.clear();
            navigate("/", { replace: true });
          } else {
            localStorage.setItem(
              "userAssociated",
              response.data.userAssociated
            );
            localStorage.setItem(
              "isProjectManager",
              response.data.isProjectManager
            );
          }
        })
        .catch((error) => {
          console.error("Error checking user role:", error);
          localStorage.clear();
          navigate("/", { replace: true });
        });
    }
  }, [authToken, navigate]);

  // If token exists, return the protected element
  if (authToken) {
    return <>{element}</>;
  }

  // Optionally return null or some loading component if you're doing a redirect
  return null;
};

export default ProtectedRoute;
